import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import IconLayout from '../IconLayout';
import PencilIcon from '../../../Icons/Pencil';
import TrashcanIcon from '../../../Icons/Trashcan';
import ConfirmationPopup from '../../../Popup/ConfirmationPopup';
import IconButton from '../../../Button/IconButton';
import { getDeviationType, deviationTypeToTranslationKey, } from '../../../DeviationViews/_helpers';
import { MobileContext } from '../../../Context';
import { DeviationTypes } from '../../../types/deviation';
export var OwnerControls = function (_a) {
    var iconClassName = _a.iconClassName, deviation = _a.deviation, onEdit = _a.onEdit, onDelete = _a.onDelete;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useState(false), isShowingConfirmation = _b[0], setShowingConfirmation = _b[1];
    var type = getDeviationType(deviation);
    var typeName = t(deviationTypeToTranslationKey(type));
    var canEdit = deviation.extended &&
        deviation.extended.canUserEdit &&
        !(isMobile &&
            [DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(type) &&
            deviation.textContent &&
            deviation.textContent.html.type === 'draft');
    return (React.createElement(React.Fragment, null,
        canEdit && (React.createElement(IconLayout, { title: t('actionbar.edit') },
            React.createElement(IconButton, { tooltipText: isMobile ? undefined : t('actionbar.edit'), onClick: function () {
                    onEdit({ deviation: deviation });
                }, className: classnames(iconClassName) },
                React.createElement(PencilIcon, null)))),
        React.createElement(IconLayout, { title: t('actionbar.delete') },
            React.createElement(IconButton, { tooltipText: isMobile ? undefined : t('actionbar.delete'), onClick: function () { return setShowingConfirmation(true); }, className: classnames(iconClassName) },
                React.createElement(TrashcanIcon, null))),
        React.createElement(ConfirmationPopup, { isOpen: isShowingConfirmation, title: t('actionbar.delete.confirm', { type: typeName }), text: t('actionbar.delete.cantGoBack'), confirmBtnLabel: t('actionbar.delete'), confirmBtnType: "danger", onConfirm: function () {
                setShowingConfirmation(false);
                onDelete({ deviation: deviation, shouldRedirect: true });
            }, onCancel: function () { return setShowingConfirmation(false); } })));
};
OwnerControls.displayName = 'OwnerControls';
export default OwnerControls;
//# sourceMappingURL=OwnerControls.js.map